import { useCallback } from 'react';
import { markWhatsNewSeen } from '../../services/user';
import { useUser } from '../../providers/UserProvider';
import { withGpSeenRelease } from './seenRelease';

export function useMarkGpReleaseSeen(failureMessage: string): (version: string) => Promise<void> {
    const { user, updateUser } = useUser();

    return useCallback(
        async (version: string) => {
            try {
                const serverReleases = await markWhatsNewSeen(version);
                updateUser({
                    database: {
                        ...user!.database,
                        data: withGpSeenRelease(user!.database.data, version, serverReleases)
                    }
                });
            } catch (error) {
                console.error(failureMessage, error);
            }
        },
        [user, updateUser, failureMessage]
    );
}
